/// <reference path="../types/index.d.ts" />

import '../client_forms/thecateredaffairbawed/style.css';
import FormStructure from './thecateredaffairbawed/form_structure';

export default FormStructure;